export const DOWNLOAD_PACKAGE_FROM_S3 = 'https://dhs-sites.s3.amazonaws.com/SDR/admin2/';
